import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto pt-3" }
const _hoisted_3 = { class: "py-10 flex justify-between" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "max-w-screen-2xl m-auto grid grid-cols-1 gap-3 pb-8" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex flex-col pt-3" }
const _hoisted_8 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _cache[5] || (_cache[5] = _createElementVNode("div", { id: "selectModal" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.save_error)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              class: "bg-next-orange mb-5 sticky top-0 z-50"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Non è stato possibile effettuare il salvataggio, correggi gli errori. ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.paths }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
              class: "w-48 hidden text-sm sm:block py-2 px-4"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            }),
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _ctx.save,
              class: "w-48 text-sm sm:block py-2 px-4 ml-3"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Salva "),
                _createElementVNode("i", { class: "spinner" }, null, -1)
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "font-bold text-xl mb-3" }, "Termini di pagamento progetti", -1)),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form_data, (b, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "border border-next-gray rounded p-3"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Field, { field_name: "Termini di pagamento" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VueMultiselect, {
                      modelValue: b.termine_pagamento,
                      "onUpdate:modelValue": ($event: any) => ((b.termine_pagamento) = $event),
                      options: _ctx.terminiDiPagamentoAutocomplete.options,
                      placeholder: "Scegli termine di pagamento",
                      class: "next-vue-multiselect-single",
                      "track-by": "id",
                      label: "descrizione",
                      selectLabel: "",
                      deselectLabel: "",
                      selectedLabel: "",
                      "internal-search": false,
                      onSearchChange: _ctx.terminiDiPagamentoAutocomplete.search
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onSearchChange"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Field, {
                  field_name: b.azienda_gruppo_nome,
                  errors: _ctx.getErrors(i,'termini_condizioni')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "p-3 border-next-gray-md-dark border-2 w-full",
                      rows: "2",
                      "onUpdate:modelValue": ($event: any) => ((b.termini_condizioni) = $event)
                    }, null, 8, _hoisted_8), [
                      [_vModelText, b.termini_condizioni]
                    ])
                  ]),
                  _: 2
                }, 1032, ["field_name", "errors"])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}